import _ from 'underscore'
import Vue from 'vue'
import ExportUsers from '../../resources/exportUsers'
import ExportSubscribers from '../../resources/exportSubscribers'

// This is an object where ads will be stored
// with keys as the id, and ad as the value
const state = {
  
}

const getters = {
  
}

const actions = {
  exportUsers(context, payload) {
    ExportUsers.query({}).then((res) => {
      if (_.isFunction(payload.callback)) payload.callback(res.body);
    }, (res) => {
      Toast.error('Failed to export users')
    })
  },

  exportSubscribers(context, payload) {
    ExportSubscribers.query({}).then((res) => {
      if (_.isFunction(payload.callback)) payload.callback(res.body);
    }, (res) => {
      Toast.error('Failed to export subscribers')
    })
  },
}

const mutations = {

  EXPORT_USERS_SUCCESS(state, payload) {
    
  },

  EXPORT_SUBSCRIBERS_SUCCESS(state, payload) {

  },

}



export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user-exporter.js